export default "__VITE_ASSET__CVWOUdvZ__"